import axios from "axios";
import { makeQuery } from "utils/utils";
import { api } from "../../../../defaults";

export const getSiteSearchResults = async (query) => {
  try {
    const queryString = makeQuery(query);
    const uri = encodeURI(
      `${api.searchUri}${api.searchEndpoint}?${queryString}`
    );

    const res = await axios.get(uri);

    return (res.data && JSON.parse(res.data)) || {};
  } catch (error) {
    console.error(`Error @ SearchBar[getSiteSearchResults]: ${error?.message}`);
    return {};
  }
};

export const searchUrlResolver = (url) => {
  const { pathname } = new URL(url);

  if (/\/pages\/|\\pages\\/.test(pathname)) {
    const _path = pathname.split(/\/pages\/|\\pages\\/).pop();
    return _path === "home" ? "/" : `/${_path}`;
  } else if (/\/data\/|\\data\\/.test(pathname)) {
    return pathname.split("/data").pop();
  } else {
    return pathname.includes("/") ? pathname : null;
  }
};

export const dedupeResults = (result) => {
  return (
    result?.hits?.hit?.reduce((acc, obj) => {
      const [resultType] = obj?.fields?.type;
      if (resultType === "pages") {
        let targetURL = searchUrlResolver(obj?.fields?.url[0]);
        if (!targetURL || !targetURL.length) {
          return acc;
        }

        obj.fields.url = targetURL;

        const exists = acc.some((elem) => elem.fields.url === targetURL);

        return exists ? acc : [...acc, obj];
      }

      if (resultType === "document") {
        obj.fields.url = "/search/document";
        return [...acc, obj];
      }

      return [...acc, obj];
    }, []) ?? []
  );
};
